import React from 'react';
import hero1Image from '../assets/images/hero_1.jpg';
import hero2Image from '../assets/images/hero_2.jpg';
import hero3Image from '../assets/images/hero_3.jpg';
import hero1Video from '../assets/videos/hero_1.mp4';
import hero2Video from '../assets/videos/hero_2.mp4';
import hero3Video from '../assets/videos/hero_3.mp4';

interface BeforeAfterItemProps {
  imageUrl: string;
  videoUrl: string;
  label: string;
}

function BeforeAfterItem({ imageUrl, videoUrl }: BeforeAfterItemProps) {
  return (
    <div className="flex-1">
      <div className="relative">
        <div className="relative w-full pb-[140%] rounded-xl md:rounded-2xl overflow-hidden shadow-lg">
          <div className="absolute inset-0">
            <video
              src={videoUrl}
              className="absolute inset-0 w-full h-full object-cover"
              loop
              muted
              playsInline
              autoPlay
            />
            <div className="absolute bottom-3 md:bottom-4 right-3 md:right-4 w-24 md:w-32 aspect-square rounded-lg overflow-hidden shadow-lg border-2 border-white">
              <img 
                src={imageUrl} 
                alt="Original" 
                className="w-full h-full object-cover"
              />
              <p className="absolute bottom-0 inset-x-0 text-[10px] font-medium text-white bg-black/50 py-1 text-center">
                選択したAIアクター
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function BeforeAfter() {
  const items = [
    {
      imageUrl: hero1Image,
      videoUrl: hero1Video,
      label: '商品紹介'
    },
    {
      imageUrl: hero2Image,
      videoUrl: hero2Video,
      label: 'サービス説明'
    },
    {
      imageUrl: hero3Image,
      videoUrl: hero3Video,
      label: 'ブランディング'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-8 max-w-[85rem] mx-auto px-4 md:px-6">
      {items.map((item, index) => (
        <div key={index} className={`${index === 2 ? 'hidden md:block' : ''}`}>
          <BeforeAfterItem {...item} />
        </div>
      ))}
    </div>
  );
} 